// Redirect /cart page loads to homepage + open drawer
if (window.location.pathname === '/cart') {
  sessionStorage.setItem('openCartDrawer', '1');
  window.location.replace('/');
}
// Auto-open drawer after redirect from /cart
if (sessionStorage.getItem('openCartDrawer')) {
  sessionStorage.removeItem('openCartDrawer');
  document.addEventListener('DOMContentLoaded', function() {
    openCartDrawer();
  });
}

function openCartDrawer(e) {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-item-count").forEach((el) => {
    el.innerText = count;
  });
}
function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  // Forms wrapped in <product-form> have their own handler in product-form.js.
  // Skip here to prevent double cart/add (was adding 2× of any 4-pack on a single click).
  if (form.closest("product-form")) return;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const labelSpan = form.querySelector("span");
    const cartText = labelSpan.textContent;
    labelSpan.textContent = "Adding to cart...";

    let res;
    try {
      // Accept: application/json forces Shopify to return JSON instead of
      // redirecting to /cart; X-Requested-With marks this as AJAX;
      // cache: no-store prevents stale 304s on the add.
      res = await fetch("/cart/add.js", {
        method: "post",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        cache: "no-store",
        body: new FormData(form),
      });
    } catch (err) {
      console.error("cart/add submit failed", err);
      labelSpan.textContent = cartText;
      return;
    }

    if (!res.ok) {
      const errText = await res.text().catch(function () { return ""; });
      console.error("cart/add.js failed", res.status, errText);
      labelSpan.textContent = cartText;
      return;
    }

    await updateCartDrawer();

    labelSpan.textContent = cartText;

    // Open cart drawer
    openCartDrawer(e);
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((el) => {
  el.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

async function updateCartDrawer() {
  // cache: no-store + Accept: text/html prevents the browser from re-serving
  // a stale 304 of the empty cart-drawer. Shopify's etag on this section is
  // keyed on the product page state (page_cache:...ProductDetailsController),
  // NOT on cart state, so without no-store the drawer re-renders empty even
  // after a successful add.
  const res = await fetch("/?section_id=cart-drawer", {
    cache: "no-store",
    headers: { "Accept": "text/html" },
  });
  const text = await res.text();

  const div = document.createElement("div");
  div.innerHTML = text;

  const newBox = div.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  // No re-attach needed — listeners are delegated on the outer .cart-drawer
  // (which is never replaced), so refreshed inner DOM is handled automatically.
}

// One-time delegated listeners on the outer .cart-drawer element. Previously
// addCartDrawerListeners() was called inside updateCartDrawer() and attached
// a fresh click handler to the outer .cart-drawer on every refresh, stacking
// N handlers after N cart updates (the outer element is NOT replaced — only
// its innerHTML is). Delegation attaches once and survives innerHTML swaps.
function initCartDrawerOnce() {
  const drawer = document.querySelector(".cart-drawer");
  if (!drawer || drawer.dataset.bound === "1") return;
  drawer.dataset.bound = "1";

  drawer.addEventListener("click", async (e) => {
    // Click on the X close button → close
    if (e.target.closest(".cart-drawer-header-right-close")) {
      closeCartDrawer();
      return;
    }
    // Click on the overlay (outside the box) → close
    if (!e.target.closest(".cart-drawer-box")) {
      closeCartDrawer();
      return;
    }
    // Quantity +/- → update
    const qtyBtn = e.target.closest(".cart-drawer-quantity-selector button");
    if (qtyBtn) {
      const rootItem = qtyBtn.closest("[data-line-item-key]");
      if (!rootItem) return;
      const key = rootItem.getAttribute("data-line-item-key");
      const input = qtyBtn.parentElement.querySelector("input");
      const currentQuantity = Number(input ? input.value : 0);
      const isUp = qtyBtn.classList.contains(
        "cart-drawer-quantity-selector-plus",
      );
      const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

      try {
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          cache: "no-store",
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        if (!res.ok) {
          console.error("cart/update.js failed", res.status);
          return;
        }
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      } catch (err) {
        console.error("cart/update submit failed", err);
      }
    }
  });
}

initCartDrawerOnce();

// ── Route-proof checkout ───────────────────────────────────────────────────
// The Route package-protection app auto-detects the cart-drawer checkout
// control and rewrites its href to "javascript:void(0)" while binding a dead
// click handler — so "Checkout" did nothing. We intercept the click in the
// CAPTURE phase on document (verified to run before Route's handler),
// stopImmediatePropagation() to kill Route's handler, and navigate to Shopify
// checkout ourselves. We also keep the href restored to /checkout so hover,
// middle-click, and native navigation still work.
(function () {
  document.addEventListener(
    "click",
    function (e) {
      var link =
        e.target && e.target.closest
          ? e.target.closest(
              'a[data-checkout-link], .cart-drawer-footer .cart-drawer-button',
            )
          : null;
      if (link) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = "/checkout";
      }
    },
    true,
  );
  function restoreCheckoutHref() {
    document.querySelectorAll("a[data-checkout-link]").forEach(function (a) {
      if (a.getAttribute("href") !== "/checkout") a.setAttribute("href", "/checkout");
    });
  }
  restoreCheckoutHref();
  var drawer = document.querySelector(".cart-drawer");
  if (drawer && window.MutationObserver) {
    new MutationObserver(restoreCheckoutHref).observe(drawer, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["href"],
    });
  }
})();

